/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Booking Center
 * @export
 */
export const BookingCenterUI = {
    GG: 'Guernsey',
    MC: 'Monaco',
    SG: 'Singapore',
    CH: 'Switzerland'
} as const;
export type BookingCenterUI = typeof BookingCenterUI[keyof typeof BookingCenterUI];


export function instanceOfBookingCenterUI(value: any): boolean {
    for (const key in BookingCenterUI) {
        if (Object.prototype.hasOwnProperty.call(BookingCenterUI, key)) {
            if (BookingCenterUI[key as keyof typeof BookingCenterUI] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BookingCenterUIFromJSON(json: any): BookingCenterUI {
    return BookingCenterUIFromJSONTyped(json, false);
}

export function BookingCenterUIFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingCenterUI {
    return json as BookingCenterUI;
}

export function BookingCenterUIToJSON(value?: BookingCenterUI | null): any {
    return value as any;
}

export function BookingCenterUIToJSONTyped(value: any, ignoreDiscriminator: boolean): BookingCenterUI {
    return value as BookingCenterUI;
}

